const STORAGE_PREFIX = 'cloudcms:'

export function getStorageKey(key: string): string {
  return `${STORAGE_PREFIX}${key}`
}

export function getLocalDraft<T>(key: string): T | null {
  try {
    const stored = localStorage.getItem(getStorageKey(`draft:${key}`))
    if (!stored) return null
    return JSON.parse(stored) as T
  } catch {
    return null
  }
}

export function setLocalDraft<T>(key: string, data: T): void {
  try {
    localStorage.setItem(getStorageKey(`draft:${key}`), JSON.stringify(data))
  } catch {
    console.warn('Failed to save draft to localStorage')
  }
}

export function removeLocalDraft(key: string): void {
  try {
    localStorage.removeItem(getStorageKey(`draft:${key}`))
  } catch {
    // Ignore errors
  }
}

export function getPreference<T>(key: string, defaultValue: T): T {
  try {
    const stored = localStorage.getItem(getStorageKey(`pref:${key}`))
    if (!stored) return defaultValue
    return JSON.parse(stored) as T
  } catch {
    return defaultValue
  }
}

export function setPreference<T>(key: string, value: T): void {
  try {
    localStorage.setItem(getStorageKey(`pref:${key}`), JSON.stringify(value))
  } catch {
    // Ignore errors
  }
}
